import { contactMethods, site } from '../data/site';
import ExternalLink from './ExternalLink';
import styles from './SiteFooter.module.scss';

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p className={styles.copy}>
          <span aria-hidden="true">©</span> {year} {site.name}
        </p>

        <nav aria-label="Elsewhere">
          <ul className={styles.links}>
            {contactMethods.map(({ id, label, href }) => (
              <li key={id}>
                {href.startsWith('mailto:') ? (
                  <a href={href} className={styles.link}>
                    {label}
                  </a>
                ) : (
                  <ExternalLink href={href} className={styles.link} showIcon={false}>
                    {label}
                  </ExternalLink>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default SiteFooter;
